<template>
  <div id="app" v-on:click="appClicked">
    <section id="contentCnt">
      <router-view v-on:play="$refs.audio.play()"
        v-on:pause="$refs.audio.pause()"
        v-on:pt="$refs.pt.open()"/>
    </section>
    <Transition ref="pt"/>
    <Audio ref="audio"/>
  </div>
</template>

<script>
import Audio from '@/components/Audio.vue';
import Transition from '@/components/Transition.vue';

export default {
  name: 'home',
  components: { Audio, Transition },
  data() {
    return {
      firstInteraction: false,
    };
  },
  methods: {
    appClicked() {
      // if (!this.firstInteraction) this.$refs.audio.play();
      // this.firstInteraction = true;
    },
  },
  watch: {
    $route(e) {
      // this.$refs.pt.open();
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss">
@font-face { font-family: CarlaSansBold; src: url('assets/fonts/CarlaSansBold.ttf'); }

body{
  margin: 0; padding: 0;
  font-family: 'Karla', sans-serif;
  font-weight: 600;
  color: #a8483d;
}
button, input, textarea{
  font-family: 'Karla', sans-serif;
  font-weight: 600;
}
.modalContent{
  transition: all .2s ease;
}
.fade-enter-active,
.fade-leave-active {
  transition: all .2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  .modalContent{
    transform: scale(.9);
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all .2s ease;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
  .modalContent{
    // transform: rotate3d(1, 1, 1, 45deg);
    transform: translateX(100%);
  }
}


.fieldGroup{
  margin-bottom: 20px;
  label{
    display: block;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .field{
    border-radius: 50px;
    border: #ccc 1px solid;
    padding: 10px 16px;
    box-sizing: border-box;
    font-size: 17px;
    width: 100%;
    display: block;
    outline: 0;
    margin-left: 20px;
    color: #444;
    &:hover{
      border-color: transparent;
      box-shadow: 0 0 0 2px #999;
    }
    &:focus{
      border-color: transparent;
      box-shadow: 0 0 0 2px #444;
    }
  }
  .fieldError{
    color: red;
    font-size: 13px;
    padding: 6px 0 0 30px;
    display: none;
    text-align: left;
    font-weight: normal;
  }
  .fieldHint{
    color: #767676;
    font-size: 13px;
    text-align: left;
    margin: 4px 0 0 10px;
  }
  &.hasError{
    .field{
      border-color: transparent;
      box-shadow: 0 0 0 2px red;
    }
    .fieldError{
      display: block;
    }
    .fieldHint{
      display: none;
    }
  }
  .radioCnt{
    margin-top: -8px;
    margin-left: 20px;
    .radioItem{
      list-style: none;
      position: relative;
      padding: 8px 10px 8px 30px;
      cursor: pointer;
      .radio{
        width: 20px; height: 20px;
        border: #fff 2px solid;
        background-color: #fff;
        box-sizing: border-box;
        border-radius: 50%;
        position: absolute;
        left: 0; top: 8px;
        transition: all .2s ease;
        .radioIn{
          position: absolute;
          left: 2px; right: 2px; top: 2px; bottom: 2px;
          border-radius: 50%;
          transition: all .2s ease;
        }
        &.on{
          border-color: #fe5f00 !important;
          .radioIn{
            background-color: #fe5f00 !important
          }
        }
      }
      &:hover{
        .radio{
          border-color: #767676;
          .radioIn{
            background-color: #999;
          }
        }
      }
    }
  }
}

.btn{
  text-decoration: none;
  display: inline-block;
  padding: 12px 20px 8px;
  background-color: #f5f5f5;
  border: none;
  font-family: CarlaSansBold;
  font-size: 16px;
  cursor: pointer;
  transition: all .3s ease;
  outline: 0;
  box-sizing: border-box;
  &.rounded{
    border-radius: 50px;
  }
  &.orange{
    color: #a8483d;
    background-color: #fcdf51;
    box-shadow: 2px 6px 8px #a8483dcf;
    @media (max-width: 680px) {
      box-shadow: 0 0 8px #a8483dcf;
    }
    &:hover{
      background-color: #ffe66d;
      box-shadow: 3px 7px 8px #a8483d;
    }
  }
  &.btnLoading{
    background-color: #ce9191 !important;
    box-shadow: none !important;
    color: #ce9191; cursor: default;
    position: relative;
    &:before{
      content: "";
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      background-image: url(assets/loading.svg);
      background-size: 28px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  &.lg{
    font-size: 20px;
    padding: 14px 30px 10px;
  }
}

.bubble .close{
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-image: url(assets/close.png);
  background-size: 14px auto;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  right: 10px;
  top: 10px;
  opacity: .4;
  cursor: pointer;
  transition: all .2s linear;
  z-index: 9;
  &:hover{
    opacity: .7;
    background-color: #e5e5e5;
  }
}

.backBtn{
  height: 50px;
  line-height: 50px;
  background-color: #fcdf51;
  border-radius: 50px;
  box-shadow: -2px 6px 8px #a8483dcf;
  position: fixed;
  left: 30px; top: 20px;
  z-index: 998;
  border: none;
  color: #a8483d;
  cursor: pointer;
  padding: 0 20px;
  font-size: 18px;
  transition: all .3s ease;
  outline: 0;
  padding-left: 56px;
  @media (max-width: 680px) {
    box-shadow: 0 0 8px #a8483dcf;
    height: 40px; line-height: 40px;
    left: 10px; top: 7px;
    padding: 0;
    width: 40px;
    span{
      display: none;
    }
  }
  &:before{
    content: "";
    position: absolute;
    width: 20px; height: 20px;
    left: 20px; top: 14px;
    background-image: url(assets/share/arrow.svg);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    @media (max-width: 680px) {
      top: 10px; left: 10px;
    }
  }
  &:hover{
    background-color: #ffe66d;
    box-shadow: -3px 7px 8px #a8483d;
  }
}

.shareFooter{
  position: fixed;
  width: 40px; height: 40px;
  background-color: #fcdf51;
  border-radius: 50%;
  box-shadow: 0 0 8px #a8483dcf;
  transition: all .3s ease;
  background-size: 22px auto;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(assets/share/share.svg);
  display: none;
  left: 10px; bottom: 20px;
  transition: transform .36s ease;
  z-index: 9;
  &.open{
    transform: rotate(180deg);
    background-image: url(assets/close.png);
    background-size: 16px auto;
  }
  @media (max-width: 680px) {
    display: block;
  }
  &:hover{
    background-color: #ffe66d;
    cursor: pointer;
  }
}
.sound{
  position: fixed;
  left: 30px; top: 20px;
  z-index: 998;
  color: #fff;
  padding-left: 64px;
  font-size: 20px;
  text-shadow: 2px 2px 2px rgba(0,0,0,.4);
  padding-top: 14px;
  box-sizing: border-box;
  &.withBack{
    left: 200px;
  }
  @media (max-width: 680px) {
    top: auto; left: 60px; bottom: 20px;
    height: 40px;
    &.withBack{
      left: 56px;
    }
    .soundLabel{
      display: none;
    }
  }
  .soundBtn{
    position: absolute;
    left: 0; top: 0;
    width: 50px; height: 50px;
    background-color: #fcdf51;
    border-radius: 50%;
    box-shadow: -2px 6px 8px #a8483dcf;
    transition: all .3s ease;
    background-size: 26px auto;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(assets/share/novolume.svg);
    @media (max-width: 680px) {
      width: 40px; height: 40px;
      box-shadow: 0 0 8px #a8483dcf;
    }
    &.on{
      background-image: url(assets/share/volume.svg);
    }
    &:hover{
      box-shadow: -3px 7px 8px #a8483d;
      background-color: #ffe66d;
      cursor: pointer;
    }
  }
}

.menuToggle{
  position: absolute;
  right: 10px; top: 7px;
  width: 50px; height: 50px;
  background-color: #fcdf51;
  border-radius: 50%;
  box-shadow: 0 0 8px #a8483dcf;
  transition: all .3s ease;
  background-size: 22px auto;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(assets/share/menu-toggle.svg);
  z-index: 991; display: none;
  @media (max-width: 680px) {
    width: 40px; height: 40px; display: block;
  }
  &:hover{
    background-color: #ffe66d;
    cursor: pointer;
  }
}

.menu{
  position: absolute;
  right: 20px; top: 20px;
  display: flex;
  z-index: 99;
  border-radius: 50px;
  overflow: hidden;
  box-shadow: 2px 6px 8px #a8483dcf;
  transition: all .3s ease;
  @media (max-width: 680px) {
    right: -300px; top: 7px;
    box-shadow: 0 0 8px #a8483dcf;
    opacity: 0; z-index: 992;
    &.open{
      right: 10px; opacity: 1;
    }
  }
  .menuItem{
    background-color: #fcdf51;
    padding: 0 20px;
    padding-left: 60px;
    height: 44px;
    line-height: 44px;
    font-size: 18px;
    color: #a8483d;
    cursor: pointer;
    position: relative;
    @media (max-width: 680px) {
      height: 40px; line-height: 40px;
      font-size: 15px;
      padding: 0 12px;
      padding-left: 42px;
    }
    &:before{
      content: "";
      position: absolute;
      width: 26px; height: 26px; top: 10px; left: 22px;
      background-size: 100% auto;
      background-position: center;
      background-repeat: no-repeat;
      @media (max-width: 680px) {
        width: 20px; height: 20px;
        left: 14px;
      }
    }
    &:hover{
      background-color: #ffe66d;
    }
    &.left{
      border-right: #dec238 1px solid;
      &:before{
        background-image: url(assets/share/menu.svg);
      }
    }
    &.right{
      padding-left: 54px;
      @media (max-width: 680px) {
        padding-left: 38px;
      }
      &:before{
        top: 8px; left: 18px;
        background-image: url(assets/share/faq.svg);
        @media (max-width: 680px) {
          left: 10px;
        }
      }
    }
  }
}

.copyright{
  position: fixed;
  left: 30px; bottom: 20px; right: 20px;
  text-align: right;
  font-size: 14px;
  color: #444;
  z-index: 998;
  .copy{
    margin-bottom: -10px;
    @media (max-width: 680px) {
      display: none;
    }
  }
  .socialLink{
    position: absolute;
    left: 0; bottom: 0;
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: center;
    align-items: center;
    @media (max-width: 680px) {
      position: fixed; display: block;
      bottom: -240px; left: 10px;
      opacity: 0;
      transition: all .5s ease;
      &.open{
        bottom: 60px;
        opacity: 1;
      }
    }
    .sclLabel{
      display: none;
    }
    .sclItem{
      width: 50px; height: 50px;
      background-color: #fcdf51;
      border-radius: 50%;
      margin-right: 10px;
      box-shadow: -2px 6px 8px #a8483dcf;
      transition: all .3s ease;
      background-size: 26px auto;
      background-position: center;
      background-repeat: no-repeat;
      display: block;
      @media (max-width: 680px) {
        width: 40px; height: 40px;
        margin-bottom: 6px;
        box-shadow: 0 0 8px #a8483dcf;
        background-size: 20px auto;
      }
      &.ig{
        background-image: url(assets/share/instagram.svg);
      }
      &.fb{
        background-image: url(assets/share/facebook.svg);
      }
      &.tw{
        background-image: url(assets/share/twitter.svg);
      }
      &.wa{
        background-image: url(assets/share/whatsapp.svg);
      }
      &:hover{
        box-shadow: -3px 7px 8px #a8483d;
        background-color: #ffe66d;
        cursor: pointer;
      }
    }
  }
}
</style>
